<template>
  <div>
    <div class="home-public-wrap">
      <h3 class="home-public-list-title">{{ channelDetail.channelName }}</h3>

      <ul class="home-public-list" v-loading="loading">
        <li v-for="item in newsList" :key="item.id">
        <router-link :to="{path:'/newsDetail',query:{channelId: channelId, newsId: item.id}}">
          <a
            href="javascript:void(0)"
            class="d-flex"
          >
            <div class="flex-fill content">{{item.title}}</div>
            <span class="flex-0 time">{{item.publishDate | formatDate}}</span>
          </a>
        </router-link>
        </li>
      </ul>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-size="size"
        :total="total"
      ></pagination>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { getChannelDetail } from '@/api/channel'
import { getNewsList } from '@/api/news'
export default {
  data() {
    return {
      title: '',
      size: 10,
      page: 1,
      total: 100,
      channelId: null,
      newsList: [],
      channelDetail: {},
      loading: true
    }
  },
  watch: {
    $route(to, from) {
      this.channelId = to.query.channelId
      this.newsList = []
      this.getChannelDetailData()
    }
  },
  methods: {
    // 分页
    handleSizeChange(val) {
      this.size = val
      this.getChannelDetailData()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getChannelDetailData()
    },
    getChannelDetailData() {
      getChannelDetail(this.channelId).then(res => {
        if (res.status === 1) {
          this.channelDetail = res.data
          this.loading = true
          getNewsList({
            page: this.page,
            size: this.size,
            channelCode: res.data.channelCode,
            state: 2
          }).then(res => {
            if (res.status === 1) {
              this.total = res.data.total
              this.newsList = res.data.rows
              this.loading = false
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    }
  },
  created() {
    this.channelId = this.$route.query.channelId
  },
  mounted() {
    this.getChannelDetailData()
  },
  filters: {
    format(value) {
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    },
    formatDate(value) {
      return moment(value).format('YYYY-MM-DD')
    }
  }
}
</script>

<style lang="scss" scoped>
.home-public-list-title {
  font-size: 24px;
  color: #3b78e7;
  font-weight: bold;
}

.home-public-list {
  padding: 20px;
  font-size: 14px;

  li {
    border-bottom: 1px solid #ddd;

    a {
      padding: 15px 0;
    }

    &:hover {
      .content,
      .time {
        color: #3b78e7;
      }

      border-bottom-color: #3b78e7;
    }
  }

  .content {
    color: #333333;
  }

  .time {
    color: #999999;
  }
}
</style>
